import { render, staticRenderFns } from "./Template-00.vue?vue&type=template&id=3111efb5&scoped=true&"
import script from "./Template-00.vue?vue&type=script&lang=js&"
export * from "./Template-00.vue?vue&type=script&lang=js&"
import style0 from "./Template-00.vue?vue&type=style&index=0&id=3111efb5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3111efb5",
  null
  
)

export default component.exports